import React from 'react'

interface ChatInspirationRefreshIconProps {
  size?: number
  color?: string
}

const ChatInspirationRefreshIcon: React.FC<ChatInspirationRefreshIconProps> = ({
  size = 24,
  color = 'white',
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_437_15173)">
        <rect width="24" height="24" rx="12" fill="black" fillOpacity="0.3" />
        <path
          d="M15.3343 7.54913C17.8041 9.44412 18.2701 12.9825 16.3751 15.4523C14.4801 17.9221 10.9417 18.3881 8.47191 16.4931C6.00209 14.5982 5.5361 11.0598 7.43108 8.58996C8.34481 7.39905 9.64063 6.67404 11.0145 6.45495M15.3343 7.54913L14.9511 10.3634M15.3343 7.54913L18.1486 7.93227"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_437_15173">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChatInspirationRefreshIcon
